///////////////////////////////////////////////////

import { limitOrderFormApiConnector } from 'apiConnector/secondary-market/limit-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { limitOrderActions } from 'state/secondaryMarket/limit-order/limitOrder.actions';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import type { EpicWithThunk } from 'state/state.common';
import { mapErrorKind } from 'utils/errors/errors';
import type { HttpError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function initLimitOrderFormEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { init } = limitOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_INIT_FORM_FETCH_REQUESTED'),
      mergeMap(({ bcsProductKey, tabId, tradeWay, client, custodian }) =>
        init({ productKeyRequest: bcsProductKey, tradeWay: tradeWay, client, custodian }).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(response => limitOrderThunks.initFormFetchedThunk(tabId, response, custodian)),
          catchError((err: HttpError) =>
            of(limitOrderActions.initFormFetchedFailed(tabId, err?.payload?.message, mapErrorKind(err))),
          ),
        ),
      ),
    );
  };
}
